/**
 * CRM Forms API
 * Patient form management and approval operations
 */

import { crmGet, crmPatch } from './crmConfig';

/**
 * Fetch pending patient forms
 */
export const fetchPendingForms = async () => {
  const response = await crmGet('/api/patientform/pending');
  return response.data;
};

/**
 * Fetch all patient forms
 * @param {Object} params - Optional query parameters
 */
export const fetchAllForms = async (params) => {
  const response = await crmGet('/api/patientform', params);
  return response.data;
};

/**
 * Approve a patient form
 * @param {string} id - Form ID
 * @param {string} type - Form type
 */
export const approveForm = async (id, type) => {
  const response = await crmPatch(`/api/patientform/approve/${id}/${type}`);
  return response.data;
};
